import { Banner, SpinnerWheel } from '@loadsmart/miranda-react'

import { getSubmitAnalysis, type Proposal } from '../domain/Proposal'

type SubmitBannersProps = {
  proposal: Proposal
}

export function SubmitBanners({ proposal }: SubmitBannersProps) {
  const { submitting, submitFail, submitSuccess } = getSubmitAnalysis(proposal)

  if (submitting) {
    return (
      <Banner>
        <Banner.Icon>
          <SpinnerWheel />
        </Banner.Icon>
        <Banner.Title>
          The offer is being submitted. Once completed, the shipper will be notified, and you'll be
          able to withdraw the offer.
        </Banner.Title>
      </Banner>
    )
  }

  if (submitFail) {
    return (
      <Banner variant="danger" dismissible>
        <Banner.Title>
          We're sorry, the offer submission failed to complete. Please try submitting the offer
          again.
        </Banner.Title>
      </Banner>
    )
  }

  if (submitSuccess) {
    return (
      <Banner variant="success" dismissible>
        <Banner.Title>Your offer was successfully sent.</Banner.Title>
        <Banner.Description>
          You will be notified by e-mail when the shipper awards the lanes.
        </Banner.Description>
      </Banner>
    )
  }

  return null
}
